module.exports = __webpack_public_path__ + "img/couples-047.a717ec31.jpg";